import { useState } from "react";
import { cn } from "@/lib/utils";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  fallback?: string;
  className?: string;
}

const Image = ({ src, alt, fallback, className, ...props }: ImageProps) => {
  const [error, setError] = useState(false);

  return (
    <img
      src={error && fallback ? fallback : src}
      alt={alt}
      className={className}
      onError={() => fallback && setError(true)}
      {...props}
    />
  );
};

Image.displayName = "Image";

export { Image }; 